/*
 * Copyright (c) 2026 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React, { Fragment, memo, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Component imports
import { Space, Typography } from 'antd';
import { GraphContext } from '../../FlowGraph';
import LimitedConnectionsHandle from '../../LimitedConnectionsHandle';
import NodeWrapper from '../../NodeWrapper';

// Misc imports
import { GRAPH_LAYOUTS, NODE_TYPES_PROPERTIES } from '../../../../constants/flowGraph';

const { Text } = Typography;

const LogoutNode = ({ id, type, data, dragging, selected }) => {
  const nodeProps = NODE_TYPES_PROPERTIES[type];
  const { t } = useTranslation();
  const { graphDirection } = useContext(GraphContext);

  const isVertical = graphDirection === GRAPH_LAYOUTS.VERTICAL;

  const NodeContents = useMemo(() => {
    return (
      <Fragment>
        <LimitedConnectionsHandle type="target" position={isVertical ? 'top' : 'left'} />

        <div className="content">
          <Space size={6} className="node-header">
            {nodeProps.icon}
            {nodeProps.label}
          </Space>

          <Text className="text-color-default fs-xs">
            {data.idpLogout ? t('Signs out from IdP') : t('Clears auth session')}
          </Text>
        </div>

        <LimitedConnectionsHandle id={id} type="source" position={isVertical ? 'bottom' : 'right'} allowedOutgoingEdgesCount={1} />
      </Fragment>
    );
  }, [data, nodeProps, isVertical, id, t]);

  return (
    <NodeWrapper
      id={id}
      type={type}
      data={data}
      children={NodeContents}
      dragging={dragging}
      selected={selected}
    />
  );
};

LogoutNode.propTypes = {
  data: PropTypes.object,
  id: PropTypes.string,
  dragging: PropTypes.bool,
  selected: PropTypes.bool,
  type: PropTypes.string,
  xPos: PropTypes.number,
  yPos: PropTypes.number
};

export default memo(LogoutNode);
